import { useScrollReveal } from "@/hooks/useScrollReveal";
import SectionTitle from "./SectionTitle";

const job1Rows = [
  { label: "職種", value: "交通誘導スタッフ" },
  { label: "雇用形態", value: "アルバイト・パート" },
  { label: "給与", value: "日給：10,000円〜（夜間：11,000円〜）※日払い・週払いOK" },
  { label: "仕事内容", value: "ガス工事・通信回線工事・建設現場などで歩行者・車両を誘導し安全を守るお仕事" },
  { label: "入社後の流れ", value: "座学研修→実技研修→OJT研修の3ステップ。研修費会社負担" },
  { label: "試用期間", value: "あり（雇用条件は本採用時と同じ）" },
  { label: "勤務地", value: "大阪府内全域" },
  { label: "応募資格", value: "不問。未経験歓迎・シニア歓迎" },
  { label: "勤務時間", value: "① 8:00〜17:00（休憩1h以上）② 20:00〜翌5:00（休憩1h以上）" },
  { label: "交通費", value: "支給あり（車・バイク・電車それぞれ対応）" },
  { label: "社会保険", value: "社会保険・雇用保険等あり" },
  { label: "入社祝い金", value: "あり（詳細は面接時にご確認ください）" },
  { label: "ご応募", value: "お電話またはフォームよりご応募ください。面接後、現場の日程を調整します。面接は弊社事務所にて行います。" },
];

const job2Rows = [
  { label: "職種", value: "高速道路警備スタッフ" },
  { label: "雇用形態", value: "アルバイト・パート" },
  { label: "給与", value: "日給：14,000円〜20,000円（日払い・週払いOK）" },
  { label: "仕事内容", value: "高速道路上での工事を安全に進めるための車線規制・コーン設置・車両誘導など（基本3名体制）" },
  { label: "勤務地", value: "大阪府大阪市浪速区（難波事務所に集合）" },
  { label: "勤務時間", value: "18:00〜翌6:00 / 6:00〜18:00（短期・単発相談可）" },
  { label: "給与保証", value: "業務が早く終了した場合も1日分の給与保証あり" },
  { label: "応募資格", value: "不問。未経験歓迎・シニア歓迎" },
  { label: "入社祝い金", value: "あり" },
];

function JobTable({ rows }: { rows: { label: string; value: string }[] }) {
  return (
    <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
      <table className="w-full text-sm">
        <tbody>
          {rows.map((row, i) => (
            <tr key={row.label} className={i % 2 === 0 ? "bg-gray-50" : "bg-white"}>
              <th className="text-left font-bold text-navy py-3.5 px-4 md:px-6 w-28 md:w-40 shrink-0 align-top">
                {row.label}
              </th>
              <td className="text-gray-700 py-3.5 px-4 md:px-6 align-top">{row.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function RecruitJobDetailsSection() {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.1);

  return (
    <section className="bg-white py-16 md:py-24" id="job-details">
      <div className="w-full px-4 md:px-8 max-w-5xl mx-auto" ref={ref}>
        <div
          className={`transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <SectionTitle en="RECRUIT" ja="募集要項" />

          <div className="space-y-12">
            <div>
              <h3 className="text-[15px] md:text-xl font-bold text-navy mb-4 flex items-center gap-2">
                <span className="w-6 h-6 flex items-center justify-center text-gold">
                  <i className="ri-road-map-line"></i>
                </span>
                ① 交通誘導スタッフ（アルバイト・パート）
              </h3>
              <JobTable rows={job1Rows} />
            </div>

            <div>
              <h3 className="text-lg md:text-xl font-bold text-navy mb-4 flex items-center gap-2">
                <span className="w-6 h-6 flex items-center justify-center text-gold">
                  <i className="ri-car-line"></i>
                </span>
                ② 高速道路警備スタッフ（アルバイト・パート）
              </h3>
              <JobTable rows={job2Rows} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}